import { z } from 'zod'

export const EditTeeTimesSchema = z.object({
  status: z.number().nullable(),
  is_golf_id_required: z.boolean().nullable(),
  slots: z.union([z.number().min(1).max(10), z.null()]),
  is_prime_time: z.boolean().nullable(),
})
